import React, { useContext } from 'react'

import NiceModal from '@ebay/nice-modal-react'
import { LightTheme, StardustProvider, Loading } from '@myxplor/stardust'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { GlobalStyles } from '~/assets/GlobalStyles'
import { AuthContext } from '~/contexts/AuthContext'
import RegistrationProvider from '~/contexts/RegistrationContext'
import Navigation from '~/layouts/Navigation'
import AdminLogin from '~/pages/AdminLogin'
import Enrolments from '~/pages/Enrolments'
import AccsUpdateState from '~/pages/Enrolments/AccsApplication/AccsUpdateState'
import ProviderPersonnel from '~/pages/ProviderPersonnel'
import ServicePersonnel from '~/pages/ServicePersonnel'

import Submissions from '~/pages/Submissions'

import Dashboard from './Dashboard'

import AddCertificate from './Enrolments/AccsApplication/AddCertificate'
import AddDetermination from './Enrolments/AccsApplication/AddDetermination'
import CopyCertificateToSubmission from './Enrolments/AccsApplication/CopyCertificateToDetermination'
import ViewAccsSubmission from './Enrolments/AccsApplication/ViewAccsSubmission'
import CcsEnrolmentSave from './Enrolments/CcsEnrolment/CreateCCSEnrolmentMasterRoll/CcsEnrolmentSave'
import GovRegistration from './GovRegistration'

import KinderAcquittals from './KinderSubmissions/KinderAcquittals'
import AcquittalResults from './KinderSubmissions/KinderAcquittals/AcquittalResults/AcquittalResults'
import KinderForecast from './KinderSubmissions/KinderForecast'
import ForecastResults from './KinderSubmissions/KinderForecast/ForecastResults/ForecastResults'
import AddMancon from './ProviderPersonnel/AddMancon'
import NotifyProviderPersonnel from './ProviderPersonnel/NotifyProviderPersonnel'
import ProviderSelect from './ProviderPersonnel/ProviderSelect'
import RemoveManconRole from './ProviderPersonnel/RemoveManconRole'
import UpdateMancon from './ProviderPersonnel/UpdateMancon'
import SaveKinderCredentials from './SaveKinderCredentials'
import AddContact from './ServicePersonnel/AddContact'
import AddOperat from './ServicePersonnel/AddOperat'
import NotifyServicePersonnel from './ServicePersonnel/NotifyServicePersonnel'
import RemoveRole from './ServicePersonnel/RemoveRole'
import UpdateContact from './ServicePersonnel/UpdateContact'
import UpdateOperat from './ServicePersonnel/UpdateOperat'

const App = () => {
  const { authToken, doingInitialRefresh } = useContext(AuthContext)

  if (doingInitialRefresh)
    return (
      <StardustProvider activeTheme={'light'} themes={{ light: LightTheme }}>
        <Loading size="large" />
      </StardustProvider>
    )
  return (
    <StardustProvider activeTheme={'light'} themes={{ light: LightTheme }}>
      <GlobalStyles />
      <NiceModal.Provider>
        <Router>
          {!authToken && (
            <Routes>
              <Route path="*" element={<AdminLogin />} />
            </Routes>
          )}
          {authToken && (
            <Routes>
              <Route
                path="/"
                element={
                  <RegistrationProvider>
                    <Navigation />
                  </RegistrationProvider>
                }>
                <Route path="/gov-registrations/*" element={<GovRegistration />} />

                <Route path="/services/:serviceId">
                  <Route path="personnel/:personId/operat/update" element={<UpdateOperat />} />
                  <Route path="personnel/:personId/contact/update" element={<UpdateContact />} />
                  <Route path="personnel/contact/add" element={<AddContact />} />
                  <Route path="personnel/operat/add" element={<AddOperat />} />
                  <Route path="personnel/:personId/remove" element={<RemoveRole />} />
                  <Route path="personnel/:personId/notify" element={<NotifyServicePersonnel />} />
                  <Route path="personnel/*" element={<ServicePersonnel />} />
                  <Route
                    path="enrolments/:childId/certificates/:certificateId/update-state/"
                    element={<AccsUpdateState />}
                  />
                  <Route
                    path="enrolments/parent/:parentId/care-enrolment/:careId/ccs-enrolment-save"
                    element={<CcsEnrolmentSave />}
                  />
                  <Route path="enrolments/:enrolmentId/certificate/add" element={<AddCertificate />} />
                  <Route path="enrolments/:enrolmentId/determination/add" element={<AddDetermination />} />
                  <Route
                    path="enrolments/:enrolmentId/accs/view-submission"
                    element={<ViewAccsSubmission />}
                  />
                  <Route
                    path="enrolments/:enrolmentId/accs/certificate-to-determination"
                    element={<CopyCertificateToSubmission />}
                  />
                  <Route path="enrolments/*" element={<Enrolments />} />
                  <Route
                    path="kinder-submissions/period-results/:agreementNumber/period/:period/year/:year"
                    element={<ForecastResults />}
                  />
                  <Route
                    path="kinder-acquittal/period-results/:agreementNumber/period/:period/year/:year"
                    element={<AcquittalResults />}
                  />
                  <Route path="kinder-submissions/*" element={<KinderForecast />} />
                  <Route path="kinder-acquittals/*" element={<KinderAcquittals />} />
                  <Route path="save-kinder-credentials" element={<SaveKinderCredentials />} />
                  <Route path="submissions/:weekStart/*" element={<Submissions />} />
                  <Route path="submissions/*" element={<Submissions />} />
                  <Route path="ccs_submissions_beta/*" element={<Submissions />} />
                </Route>
                <Route path="/providers/:providerId">
                  <Route path="personnel/select" element={<ProviderSelect />} />
                  <Route path="personnel/registration/:govId/mancon/update" element={<UpdateMancon />} />
                  <Route path="personnel/registration/:govId/mancon/add" element={<AddMancon />} />
                  <Route path="personnel/registration/:govId/mancon/remove" element={<RemoveManconRole />} />
                  <Route
                    path="personnel/registration/:govId/mancon/notify"
                    element={<NotifyProviderPersonnel />}
                  />
                  <Route path="personnel/*" element={<ProviderPersonnel />} />
                </Route>
                <Route path="/dashboard/*" element={<Dashboard />} />
              </Route>
            </Routes>
          )}
        </Router>
      </NiceModal.Provider>
    </StardustProvider>
  )
}

export default App
